import { createFileRoute } from "@tanstack/react-router"
import { CommunicationEmailCampaignsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/email-campaigns"
)({
  component: () => (
    <AuthorizationGate
      resource={Resource.COMMUNICATION_TEMPLATES}
      action={Action.READ}
    >
      <CommunicationEmailCampaignsPage />
    </AuthorizationGate>
  ),
})
